/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L1Inputs */

const en_mk_term_l1 = /** @type {(inputs: Mk_Term_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`→ Task F1-T3 · Onboarding form validates +62 numbers`)
};

const id_mk_term_l1 = /** @type {(inputs: Mk_Term_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`→ Task F1-T3 · Form onboarding memvalidasi nomor +62`)
};

/**
* | output |
* | --- |
* | "→ Task F1-T3 · Onboarding form validates +62 numbers" |
*
* @param {Mk_Term_L1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l1 = /** @type {((inputs?: Mk_Term_L1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l1(inputs)
	return en_mk_term_l1(inputs)
});